import { Language } from '../config/i18nConfig'
import { getI18NName } from '../components/Combobox/i18n/I18NCombobox'
import { useTranslation } from 'react-i18next'
import useGlobalContext from './useGlobalContext'

type ReturnProps = {
    loaded: boolean
    languages: Language[]
    getLanguage: (id: string) => Language
    getLanguageName: (id: string) => string
}

export default function useLanguages(): ReturnProps {
    const { i18n } = useTranslation()

    const { entities, loaded } = useGlobalContext('languages')

    const getLanguage = (id: string) => entities.find(value => value.alpha === id)
    const getLanguageName = (id: string) =>
        getI18NName(
            entities.find(value => value.alpha === id),
            i18n.language,
        )

    return { loaded, languages: entities, getLanguage, getLanguageName }
}
